import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMenu, FiX, FiPhone, FiMail, FiLayers } = FiIcons;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'Leistungen', href: '/services' },
    { name: 'Team', href: '/team' },
    { name: 'Referenzen', href: '/references' },
    { name: 'Blog', href: '/blog' },
    { name: 'Kontakt', href: '/contact' },
    { name: 'Kundenportal', href: '/portal' }
  ];

  return (
    <header className="sticky top-0 z-50">
      {/* Announcement Bar */}
      <div className="bg-orange-100 border-b border-orange-200 py-2">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-center text-orange-800 text-xs sm:text-sm font-medium">
            🚧 Diese Website befindet sich aktuell im Umbau. Einige Funktionen oder Texte können noch unvollständig sein.
          </p>
        </div>
      </div>

      {/* Top Contact Bar */}
      <div className="bg-orange-500 text-white py-2">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center text-xs sm:text-sm">
            <div className="flex items-center space-x-4 sm:space-x-6">
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiPhone} className="w-4 h-4" />
                <span>+41 76 625 07 64</span>
              </div>
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiMail} className="w-4 h-4" />
                <span>info@hublertex.ch</span>
              </div>
            </div>
            <div className="hidden md:block">
              <span>24/7 Notfalldienst verfügbar</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <div className="bg-white shadow-lg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <Link to="/" className="flex items-center gap-3 group transition-transform duration-200 hover:scale-105" aria-label="Hubler & Tex - Zur Startseite">
              <div className="flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 bg-orange-500 rounded-xl shadow-md transform transition-all duration-300 group-hover:scale-105 group-hover:shadow-lg">
                <SafeIcon icon={FiLayers} className="w-6 h-6 sm:w-7 sm:h-7 text-white" />
              </div>
              <div className="flex flex-col">
                <div className="text-xl sm:text-2xl font-bold text-gray-900 leading-none tracking-tight">
                  <span className="text-orange-500">Hubler</span> & Tex
                </div>
                <div className="text-[10px] sm:text-xs text-gray-500 font-medium tracking-widest uppercase mt-1">
                  Facility Services
                </div>
              </div>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex space-x-6 lg:space-x-8">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`px-3 py-2 text-sm font-medium transition-colors duration-200 ${
                    location.pathname === item.href
                      ? 'text-orange-500 border-b-2 border-orange-500'
                      : 'text-gray-700 hover:text-orange-500'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
            </nav>

            {/* Mobile menu button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden p-2 rounded-md text-gray-700 hover:text-orange-500"
              aria-label="Menü öffnen"
            >
              <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="w-6 h-6" />
            </button>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              className="md:hidden pb-4"
            >
              <nav className="flex flex-col space-y-2">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    onClick={() => setIsMenuOpen(false)}
                    className={`px-3 py-2 text-sm font-medium transition-colors duration-200 ${
                      location.pathname === item.href
                        ? 'text-orange-500 bg-orange-50'
                        : 'text-gray-700 hover:text-orange-500'
                    }`}
                  >
                    {item.name}
                  </Link>
                ))}
              </nav>
            </motion.div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;